import React from 'react';
import { useTranslation } from 'react-i18next';

const OP_PLUS_LOADER_WEBCOMPONENT_NAME = 'op-plus-loader';

const OpPlusLoaderWrapper = () => {
  const { t } = useTranslation();

  const opPlusLoaderProps = {
    'is-modal': true,
    'show-logo': true,
    'loader-position': 'block',
    'loader-text': t('txt_opplus_sub_legacy_adding_inprogress_msg'),
  };

  return React.createElement(OP_PLUS_LOADER_WEBCOMPONENT_NAME, opPlusLoaderProps, null);
};
export default OpPlusLoaderWrapper;
